import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { LoginComponent } from './components/login/login.component';
import { adminroutes } from './components/admin/admin-routing.module';
import { leapmotorzoneroutes } from './components/leapmotor-zone/leapmotor-zone.routing';
import { AuthGuard } from './guards/auth.guard';
import { miarearoutes } from './components/mi-area/miarea-routing.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '2fa', 
    loadChildren: () => import('./components/2FA/2FA.module').then(m => m.TWOFAModule)
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: 'home', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule), data: { animation: 'home' } },
      { path: 'mkt-coop', loadChildren: () => import('./components/mkt-coop/mkt-coop.module').then(m => m.MktCoopModule), data: { animation: 'mkt-coop' }, canActivate: [AuthGuard] },
      { path: 'campaign', loadChildren: () => import('./components/campaign/campaign.module').then(m => m.CampaignModule), data: { animation: 'campaign' }, canActivate: [AuthGuard] },
      { path: 'admin', children: adminroutes },
      { path: 'leapmotor-zone', children: leapmotorzoneroutes },
      { path: 'mi-area', children: miarearoutes }
    ]
  },
  { path: '**', redirectTo: '/home' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0] // [x, y]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
